import { render, staticRenderFns } from "./home-page.vue?vue&type=template&id=01bbeb2b&scoped=true"
import script from "./home-page.vue?vue&type=script&lang=js"
export * from "./home-page.vue?vue&type=script&lang=js"
import style0 from "./home-page.vue?vue&type=style&index=0&id=01bbeb2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bbeb2b",
  null
  
)

export default component.exports